export const trackingEvents = {
  user_management: {
    added_single_user: "UM - Added Single New User",
    added_multiple_users: "UM - Added Multiple New Users",
    checked_available_seats_helper_text:
      "UM - Clicked on Available Seats Helper Text",
    checked_role_breakdown_helper_text:
      "UM - Clicked on Role Breakdown Helper Text",
    clicked_info_badge: "UM - Clicked on User Management Info Badge",
    clicked_on_search: "UM- Clicked on Search",
    filtered_by_role: "UM - Filtered by Role",
    filtered_by_account_state: "UM - Filtered by Account State",
    filtered_by_seat_used: "UM - Filtered by Seat Used",
    changed_single_user_role: "UM - Changed User Role",
    changed_multiple_users_roles: "UM - Changed User Roles",
    removed_single_user_from_project: "UM - Removed User from Project",
    removed_multiple_users_from_projects: "UM - Removed Users from Project",
    deleted_single_user_from_account: "UM - Deleted User from Account",
    deleted_multiple_users_from_account: "UM - Deleted Users from Account",
    sent_user_reminder_email: "UM - Send User Reminder Email",
    emailed_all_pending_users: "UM - Emailed All Pending Users",
    hovered_on_seat_badge: "UM - Hovered on Seat Badge Next to Username",
    sorted_table_by_name: "UM - Sorted Table by Name (Ascending)",
    sorted_table_by_username: "UM - Sorted Table by Username (Ascending)",
    sorted_table_by_email: "UM - Sorted Table by Email (Ascending)",
    sorted_table_by_role: "UM - Sorted Table by Role (Ascending)",
    sorted_table_by_account_state:
      "UM - Sorted Table by Account State (Ascending)"
  } as const,
  user_profile: {
    visited: "Visited Profile Page",
    updated_details: "Updated User Details",
    updated_preferences: "Updated User Preferences",
    update_password: "Changed Password"
  },
  feature_modules: {
    clicked_learn_more: "PLG-Clicked on Learn More About "
  }
} as const;
